import { render, staticRenderFns } from "./point-details.vue?vue&type=template&id=35e1abe4&scoped=true&"
import script from "./point-details.vue?vue&type=script&lang=js&"
export * from "./point-details.vue?vue&type=script&lang=js&"
import style0 from "./point-details.vue?vue&type=style&index=0&id=35e1abe4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e1abe4",
  null
  
)

export default component.exports